module.exports = __webpack_public_path__ + "img/image02.7daf0ecf.jpg";